const FunctionMixin = {
  methods: {
    getDefaultSignature() {
      return `// Documentation:
// Built-Ins: https://docs.bionicmetrics.com/guides/builtins.html
// Macros: https://docs.bionicmetrics.com/macros/

async function test(baseUrl, driver, data) {
}

await test(baseUrl, driver, data);
`;
    }
  }
};
export default FunctionMixin;
